import { scrollIntoView, findCommonParent } from '@ynap/scroll-utils';

export default function onSubmitFail(errors, dispatch, submitError, props) {
    if (errors) {
        const formEl = document.getElementById(props.form);
        if (formEl) {
            const errorField = findFirstErrorField(formEl, errors);
            if (errorField && errorField.type != 'radio' && errorField.type != 'checkbox') {
                errorField.focus();
            }

            const errorLabel = findFieldLabel(errorField);
            let commonParent = findCommonParent(errorField, errorLabel);
            if (commonParent?.offsetTop === 0 && commonParent.parentNode?.offsetTop > 0) {
                commonParent = commonParent.parentNode;
                // This is to fix the marketingConsent scroll on TON registrationForm
            } else if (
                errorField?.name === 'registration.maMarketingConsent' &&
                commonParent?.offsetParent?.className.includes('registration.maMarketingConsent')
            ) {
                commonParent = commonParent.offsetParent;
            }
            const scrollEl = commonParent || errorField || formEl;
            scrollIntoView(scrollEl, props.headerElement);
        }
    }
}

export function findFirstErrorField(form, errors) {
    const flattenedErrors = flatten(errors);
    return form.elements ? Array.from(form.elements).find((element) => flattenedErrors[element.name]) : form[0];
}

export function findFieldLabel(field) {
    if (field && field.labels && field.labels.length) {
        const [firstLabel] = field.labels;
        return firstLabel;
    }
}

function flatten(table) {
    return reduce('', {}, table);
}

function reduce(path, accumulator, table) {
    if (Array.isArray(table)) {
        const length = table.length;
        if (length) {
            let index = 0;
            while (index < length) {
                const property = `${path}[${index}]`;
                const item = table[index++];
                if (Object(item) !== item) accumulator[property] = item;
                else reduce(property, accumulator, item);
            }
        } else {
            accumulator[path] = table;
        }
    } else {
        let empty = true;

        if (path) {
            for (let property in table) {
                if (table.hasOwnProperty(property)) {
                    const item = table[property];
                    property = `${path}.${property}`;
                    empty = false;
                    if (Object(item) !== item) accumulator[property] = item;
                    else reduce(property, accumulator, item);
                }
            }
        } else {
            for (const property in table) {
                if (table.hasOwnProperty(property)) {
                    const item = table[property];
                    empty = false;
                    if (Object(item) !== item) accumulator[property] = item;
                    else reduce(property, accumulator, item);
                }
            }
        }
        if (empty) accumulator[path] = table;
    }
    return accumulator;
}
